import { NavLink } from 'react-router-dom';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/cn';
import { MODULES } from '@/config/modules';

function NavItem({
  path,
  label,
  icon: Icon,
  badge,
}: {
  path: string;
  label: string;
  icon: (typeof MODULES)[number]['icon'];
  badge?: number;
}) {
  const I = Icon as PhosphorIcon;
  return (
    <NavLink
      to={path}
      end={path === '/'}
      className={({ isActive }) =>
        cn(
          'group flex flex-none items-center gap-2 rounded-md px-3 py-2 font-mono text-[11.5px] uppercase tracking-[0.08em] transition md:gap-3',
          isActive
            ? 'bg-star/10 text-star shadow-[0_0_18px_rgba(116,207,233,.12)]'
            : 'text-faint hover:bg-white/[0.03] hover:text-dim',
        )
      }
    >
      {({ isActive }) => (
        <>
          <I className="size-[18px] flex-none" weight={isActive ? 'fill' : 'regular'} />
          <span className="truncate">{label}</span>
          {badge !== undefined && badge > 0 && (
            <span className="ml-auto rounded-full border border-amber-400/40 bg-amber-500/10 px-1.5 font-mono text-[9px] text-amber-300">
              {badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
}

export function SideNav() {
  const main = MODULES.filter((m) => m.group === 'main');
  const footer = MODULES.filter((m) => m.group === 'footer');
  return (
    <nav className="flex w-full flex-none gap-1 overflow-x-auto border-b border-line bg-bg-2/40 p-2 md:sticky md:top-[61px] md:h-[calc(100vh-61px)] md:w-[208px] md:flex-col md:overflow-x-visible md:border-b-0 md:border-r md:p-3">
      {/* F0: 화면들은 수동 영역 — 디폴트는 커널(홈)과의 대화, 직접 만질 때만 진입 */}
      <div className="hidden px-3 pb-1 pt-0.5 font-mono text-[9px] uppercase tracking-[0.18em] text-fainter md:block">직접 편집</div>
      {main.map((m) => (
        <NavItem key={m.path} {...m} />
      ))}
      <div className="mx-1 h-9 w-px flex-none bg-line md:mx-0 md:my-2 md:h-px md:w-auto" />
      {footer.map((m) => (
        <NavItem key={m.path} {...m} />
      ))}
    </nav>
  );
}
